import type { Position } from '../proto/generated/position'
import { getSecurityKey } from './security'
import { getPositionsSecurityKeys, buildLtpsByKey } from './positionLtpsSignature'

export type PositionsPnLTotals = {
    unrealised: number
    realised: number
}

export const computePositionsPnLTotals = (
    positions: Position[],
    ltpsByKey: Map<string, number>,
    priceMultipliers: Map<string, number>
): PositionsPnLTotals => {
    let unrealised = 0
    let realised = 0

    positions.forEach((position) => {
        const securityKey = getSecurityKey(position.security.exchange, position.security.code)
        const pm = priceMultipliers.get(securityKey) ?? 100
        const ltp = ltpsByKey.get(securityKey) ?? 0
        const qty = position.closePosition
        if (qty !== 0) {
            const avgPrice = position.closePositionValue / qty
            unrealised += ((ltp - avgPrice) * qty) / pm
        }
        realised += (position.realisedProfit ?? 0) / pm
    })

    return { unrealised, realised }
}

export const computePositionsTotalPnL = (
    positions: Position[],
    ltpsSignature: string,
    priceMultipliers: Map<string, number>
): number => {
    const keys = getPositionsSecurityKeys(positions)
    const ltpsByKey = buildLtpsByKey(keys, ltpsSignature)
    const { unrealised, realised } = computePositionsPnLTotals(positions, ltpsByKey, priceMultipliers)
    return unrealised + realised
}
